import styled from 'styled-components/macro';

export const ValidationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ValidationText = styled.p`
  font-size: 11px;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  color: #6d7991;
  margin: auto;
`;

export const ValidationIcon = styled.img`
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 12px;
  height: 12px;
  margin-left: 7px;
  margin-right: 7px;
`;

export const EscalatedBox = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const MessagesWrapper = styled.div`
  flex: 1;
  overflow: hidden;
`;

export const ActionsButtons = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 0 0 0;
  margin: 0 0 0 0;
  justify-content: flex-end;
`;
